import { WebClientDetailFetcher } from '~commonInfra/utils/resourceFetchers/WebClientDetailFetcher';
import { WebClientListResourceFetcher } from '~commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IPredictiveModelDetailInfo,IPredictiveModelInfo } from '~src/predictiveModel/models/IPredictiveModelInfo';
import { PredictiveModelMapper } from '~src/predictiveModel/models/mappers/PredictiveModelMapper';
import {GetPredictiveModelActionsRequest } from '~src/predictiveModel/serverApi/requests/GetPredictiveModelActionsRequest';
import {GetPredictiveModelsRequest } from '~src/predictiveModel/serverApi/requests/GetPredictiveModelsRequest';
import { IDetailFetcher } from '~src/ts/fetchers/IDetailFetcher';
import { IListFetcher } from '~src/ts/fetchers/IListFetcher';
import { ServerApiMapper } from '~src/ts/helpers/ServerModelHelper';
import { FieldValuesQuery } from '~src/ts/resources/FieldValuesQuery';
import { IActionResource, IDetailResource, IFieldValuesResource, IListResource } from '~src/ts/resources/Resource';
import { ResourceQuery } from '~src/ts/resources/ResourceQuery';
import { GetFieldValuesRequest } from '~src/ts/ServerApi/requests/GetFieldValuesRequest';
import { IFieldValue } from '~src/ts/ServerApi/types/IFieldValue';

import WebHttpClient from '../../httpClient/WebHttpClient';
import { IPredictiveModelActions } from '../serverApi/types/IPredictiveModelActions';

class PredictiveModelsResource implements IListResource<IPredictiveModelInfo>, IFieldValuesResource, IDetailResource<IPredictiveModelDetailInfo>, IActionResource<IPredictiveModelActions> {

  private listFetcher: IListFetcher<IPredictiveModelInfo> = new WebClientListResourceFetcher(GetPredictiveModelsRequest, ServerApiMapper.predictiveModels);
  private detailFetcher: IDetailFetcher<IPredictiveModelDetailInfo> = new WebClientDetailFetcher('getPredictiveModel', PredictiveModelMapper.mapDetail)
  private fieldValuesFetcher: IListFetcher<IFieldValue> = new WebClientListResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  public all(): ResourceQuery<IPredictiveModelInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public getById(id: string): Promise<IPredictiveModelDetailInfo> {
    return this.detailFetcher.fetchById(id);
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'virtualConnection');
  }

  // Actions
  public actions(id: string): Promise<IPredictiveModelActions> {
    return WebHttpClient.sendRequest(new GetPredictiveModelActionsRequest(id));
  }
}

export const PredictiveModels = new PredictiveModelsResource();
